<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import { inject, ref } from 'vue';

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const user: any = route.meta.user;
    const loading = ref(false);
    const errorMessage = ref('');
</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>

        <h4 class="s7 font-semibold px-3 pb-5">Membre / Plan Mensuel <span class="text-sm text-grey-500"></span></h4>
        <div class="s13 flex-right gap-3 mt--2 mb-5 px-5">
            <span class="btn shadow-200 white2">Prélèvement</span>
            <span class="btn shadow-200 light2 border-none">Données financières</span>
            <span class="btn shadow-200 light2 border-none">Plan Mensuel 1</span>
        </div>

        <!--User info - Component-->
        <div class="s20 widget flex align-items-center px-1 py-5">
            <div class="s2_mobile h-100p px-7">
                <div class="rounded-100 overflow-hidden item active"><!--active-->
                    <img :src="!!user.photo_url ? user.photo_url : '/assets/users_avatar/600w/user.jpg'" width="100%" />
                </div>
            </div>
            <div class="s4_mobile h-100p px-2">
                <h3 class="mb-2">C788PMKJ</h3>
                <h4>{{ user.nom + ' ' + user.prenom }}</h4>
            </div>
            <div class="s3_mobile h-100p px-2">
                <h4 class="font-normal mb-5">{{ user.collectivite?.nom }}</h4>
                <span class="tag-state warning stroke">En cours</span>
                <span class="tag-state notif stroke">Actif</span>
            </div>
            <div class="s4_mobile h-100p px-3">
                <h4 class="font-normal">
                    Date de fin de souscription <br class="mb-2"/>
                    <b class="text-2xl">11 Janvier 2028</b>
                </h4>
            </div>
            <div class="s7_mobile h-100p px-5">
                <!--Barre de progression - Component-->
                <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                    <div class="widget-floating py-0 text-xl flex-right">Utilisation</div>
                    <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green" style="width: 25%;">
                        25%
                    </div>
                </div>
                <!--End Barre de progression-->
            </div>
        </div>
        <!--End User info-->
        <div class="clear-both h-20"></div>


        <!--Prélèvement mensuel - Component-->
        <div class="s20 widget px-6 pt-8 pb-2">
            <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Prélèvement mensuel
                </span>
            </div>
            <div class="s10 mt--5-5 flex-right">
                <!-- <button class="btn lg py-3 white2 active">
                    <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                    <span>Plan mensuel</span>
                </button> -->
                <button class="btn lg py-3 black active">
                    <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                    <span>Exporter en PDF</span>
                </button>
                <button class="btn lg py-3 black active">
                    <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                    <span>Exporter en Excel</span>
                </button>
            </div>

            <div class="s20 items-center gap-6 pb-4 collapse-content active">
                <div class="clear-both h-20"></div>
                <!--Barre de progression - Component-->
                <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                    <div class="widget-floating py-0 text-xl flex-right">25%</div>
                    <div class="h-100p flex align-items-center rounded-100 px-7 bg-pop-green" style="width: 25%;">
                        <h2>250 000 F</h2><h2 class="font-medium"> &nbsp;/ 1 000 000 F</h2>
                    </div>
                </div>
                <!--End Barre de progression-->

                <div class="clear-both h-30"></div>

                <div class="grid4 px-1">
                    <!--Prélèvement - Component-->
                    <div class="widget border border-3 active shadow-200 rounded-30 gap-5 px-7 py-5">
                        <div class="s10">
                            <h6 class="secondary-font font-semibold mb-1">01 Novembre 2025</h6>
                            <h3 class="secondary-font font-semibold text-grey-900 py-1">250 000 F</h3>
                        </div>
                        <div class="s10 text-right">
                            <h5 class="secondary-font font-semibold text-grey-600 pb-2 display-none">1m 29j 24min</h5>
                            <div class="mb-4">
                                <span class="tag-state notif stroke">Effectué</span>
                            </div>
                            <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4">Le 11 Déc. 2025</h6>
                            <button class="btn-ultra w-100 shadow-0 display-none">
                                <div class="btn-show">
                                    <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                    <span>Valider</span>
                                </div>
                                <div class="btn-loading">
                                    <div class="loader-dots"></div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <!--End Prélèvement-->

                    <div class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5">
                        <div class="s10">
                            <h6 class="secondary-font font-semibold mb-1">01 Novembre 2025</h6>
                            <h3 class="secondary-font font-semibold text-grey-900 py-1">250 000 F</h3>
                        </div>
                        <div class="s10 text-right">
                            <h5 class="secondary-font font-semibold text-grey-600 pb-2">1m 29j 24min</h5>
                            <div class="mb-4  display-none">
                                <span class="tag-state notif stroke">Effectué</span>
                            </div>
                            <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none">Le 11 Déc. 2025</h6>
                            <button class="btn-ultra w-100 shadow-0">
                                <div class="btn-show">
                                    <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                    <span>Valider</span>
                                </div>
                                <div class="btn-loading">
                                    <div class="loader-dots"></div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5">
                        <div class="s10">
                            <h6 class="secondary-font font-semibold mb-1">01 Novembre 2025</h6>
                            <h3 class="secondary-font font-semibold text-grey-900 py-1">250 000 F</h3>
                        </div>
                        <div class="s10 text-right">
                            <h5 class="secondary-font font-semibold text-grey-600 pb-2">1m 29j 24min</h5>
                            <div class="mb-4  display-none">
                                <span class="tag-state notif stroke">Effectué</span>
                            </div>
                            <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none">Le 11 Déc. 2025</h6>
                            <button class="btn-ultra w-100 shadow-0 display-none">
                                <div class="btn-show">
                                    <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                    <span>Valider</span>
                                </div>
                                <div class="btn-loading">
                                    <div class="loader-dots"></div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5">
                        <div class="s10">
                            <h6 class="secondary-font font-semibold mb-1">01 Novembre 2025</h6>
                            <h3 class="secondary-font font-semibold text-grey-900 py-1">250 000 F</h3>
                        </div>
                        <div class="s10 text-right">
                            <h5 class="secondary-font font-semibold text-grey-600 pb-2">1m 29j 24min</h5>
                            <div class="mb-4  display-none">
                                <span class="tag-state notif stroke">Effectué</span>
                            </div>
                            <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none">Le 11 Déc. 2025</h6>
                            <button class="btn-ultra w-100 shadow-0 display-none">
                                <div class="btn-show">
                                    <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                    <span>Valider</span>
                                </div>
                                <div class="btn-loading">
                                    <div class="loader-dots"></div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="clear-both h-20"></div>
                
                <div class="collapse-content active">
                    <div class="grid4 px-1">
                        <div class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5">
                            <div class="s10">
                                <h6 class="secondary-font font-semibold mb-1">01 Novembre 2025</h6>
                                <h3 class="secondary-font font-semibold text-grey-900 py-1">250 000 F</h3>
                            </div>
                            <div class="s10 text-right">
                                <h5 class="secondary-font font-semibold text-grey-600 pb-2">1m 29j 24min</h5>
                                <div class="mb-4  display-none">
                                    <span class="tag-state notif stroke">Effectué</span>
                                </div>
                                <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none">Le 11 Déc. 2025</h6>
                                <button class="btn-ultra w-100 shadow-0 display-none">
                                    <div class="btn-show">
                                        <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                        <span>Valider</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5">
                            <div class="s10">
                                <h6 class="secondary-font font-semibold mb-1">01 Novembre 2025</h6>
                                <h3 class="secondary-font font-semibold text-grey-900 py-1">250 000 F</h3>
                            </div>
                            <div class="s10 text-right">
                                <h5 class="secondary-font font-semibold text-grey-600 pb-2">1m 29j 24min</h5>
                                <div class="mb-4  display-none">
                                    <span class="tag-state notif stroke">Effectué</span>
                                </div>
                                <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none">Le 11 Déc. 2025</h6>
                                <button class="btn-ultra w-100 shadow-0 display-none">
                                    <div class="btn-show">
                                        <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                        <span>Valider</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5">
                            <div class="s10">
                                <h6 class="secondary-font font-semibold mb-1">01 Novembre 2025</h6>
                                <h3 class="secondary-font font-semibold text-grey-900 py-1">250 000 F</h3>
                            </div>
                            <div class="s10 text-right">
                                <h5 class="secondary-font font-semibold text-grey-600 pb-2">1m 29j 24min</h5>
                                <div class="mb-4  display-none">
                                    <span class="tag-state notif stroke">Effectué</span>
                                </div>
                                <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none">Le 11 Déc. 2025</h6>
                                <button class="btn-ultra w-100 shadow-0 display-none">
                                    <div class="btn-show">
                                        <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                        <span>Valider</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div class="widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5">
                            <div class="s10">
                                <h6 class="secondary-font font-semibold mb-1">01 Novembre 2025</h6>
                                <h3 class="secondary-font font-semibold text-grey-900 py-1">250 000 F</h3>
                            </div>
                            <div class="s10 text-right">
                                <h5 class="secondary-font font-semibold text-grey-600 pb-2">1m 29j 24min</h5>
                                <div class="mb-4  display-none">
                                    <span class="tag-state notif stroke">Effectué</span>
                                </div>
                                <h6 class="secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none">Le 11 Déc. 2025</h6>
                                <button class="btn-ultra w-100 shadow-0 display-none">
                                    <div class="btn-show">
                                        <img src="/icons/icon-valider.svg" class="btn-icon" alt="" />
                                        <span>Valider</span>
                                    </div>
                                    <div class="btn-loading">
                                        <div class="loader-dots"></div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear-both h-15"></div>
                <span class="px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open active align-right">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Voir tous
                </span>
            </div>

        </div>

        <div class="clear-both h-5"></div>
        <div class="step vertical bg-grey-500 ml-auto mr-auto"></div>
        <div class="clear-both h-5"></div>


        <div class="s20 widget align-items-center px-6 pt-8 pb-27">
            <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Données financières
                </span>
            </div>
            <div class="clear-both h-5"></div>

            <div class="s20 collapse-content pb-7 active">
                <div class="s7 px-8">
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Salaire <br class="mb-4"/>
                        <b class="text-3xl text-grey-800">350 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Prélèvement sur salaire <br class="mb-4"/>
                        <b class="text-3xl text-grey-800">25%</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Prêt en Concession<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">2 000 000</b>
                    </h4>
                </div>
                <div class="s6 px-8">
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Prélèvement à la Solde<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">64 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Pret à Rembourser<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">2 331 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Taux Interets Microfinance<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">8,5%</b>
                    </h4>
                </div>
                <div class="s7 px-8">
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Pouvoir Achat 1 An<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">1 300 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Pouvoir Achat 3 Ans<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">4 300 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Durée Financement <br class="mb-4"/>
                        <b class="text-3xl text-grey-800">36 Mois</b> - <b class="text-3xl text-grey-800">3 ans</b>
                    </h4>
                </div>
            </div>
        </div>

        <div class="clear-both h-5"></div>
        <div class="step vertical bg-grey-500 ml-auto mr-auto"></div>
        <div class="clear-both h-5"></div>


        <!----->
        <!--*** Plan mensuel  Widget *** -->
        <div class="s20 widget shadow-100 pb-1"><!-- widget shadow-100 fill -->

            <div class="mt-6 ml-4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Plan Mensuel 1
                </span>
            </div>
            
            <div class="s20 pb-7 collapse-content active">
                <div class="container-full-2 s20 mb-5">
                    <div class="s7"><h4 class="font-semibold mt-3">Année 1 / Janv 2026 - Déc 2026</h4></div>
                    <div class="s13 flex gap-2 justify-content-right">
                        <button class="btn black normal justify-content-center mx-0 btn-filtre">
                            <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                            <span>Exporter PDF</span>
                        </button>
                        <button class="btn black normal justify-content-center mx-0 btn-filtre">
                            <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                            <span>Exporter Excel</span>
                        </button>
                    </div>
                </div>

                <table class="table separator skin1 sm selection text-right">
                    <thead>
                        <tr>
                            <th class="mode text-left pl-5">Mois</th>
                            <th>1</th>
                            <th>2</th>
                            <th>3</th>
                            <th>4</th>
                            <th>5</th>
                            <th>6</th>
                            <th>7</th>
                            <th>8</th>
                            <th>9</th>
                            <th>10</th>
                            <th>11</th>
                            <th>12</th>
                            <th class="font-semibold pr-5">Total</th>
                        </tr>
                        <tr>
                            <th class="mode text-left py-5 pl-5">&nbsp;</th>
                            <th>Janv 2026</th>
                            <th>Févr 2026</th>
                            <th>Mars 2026</th>
                            <th>Avr 2026</th>
                            <th>Mai 2026</th>
                            <th>Juin 2026</th>
                            <th>Juil 2026</th>
                            <th>Août 2026</th>
                            <th>Sept 2026</th>
                            <th>Oct 2026</th>
                            <th>Nov 2026</th>
                            <th>Déc 2026</th>
                            <th class="font-semibold pr-5"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="mode text-left pl-5">Décaissement</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td>33 300</td>
                            <td class="font-semibold pr-5">999 000</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">25% Fond de risque</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="text-red">-20 825</td>
                            <td class="font-semibold text-red pr-5">-249 900</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Crédits Mensuels</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="">62 475</td>
                            <td class="font-semibold pr-5">749 700</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Frais mensuels: 5%</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="text-red">-2 499</td>
                            <td class="font-semibold text-red pr-5">-29 988</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Renfourement: 30%</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="text-red">-18 743</td>
                            <td class="font-semibold text-red pr-5">-224 910</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Revolving Recharge</td>
                            <td>62 475</td>
                            <td>70 094</td>
                            <td>65 903</td>
                            <td>65 903</td>
                            <td>60 903</td>
                            <td>60 903</td>
                            <td>61 903</td>
                            <td>61 903</td>
                            <td>61 903</td>
                            <td>61 903</td>
                            <td>61 903</td>
                            <td>61 903</td>
                            <td class="font-semibold pr-5">1 301 772</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Cash-Back TVA</td>
                            <td class="">11 246</td>
                            <td class="">14 057</td>
                            <td class="">13 463</td>
                            <td class="">17 099</td>
                            <td class="">18 270</td>
                            <td class="">19 092</td>
                            <td class="">21 228</td>
                            <td class="">22 274</td>
                            <td class="">24 077</td>
                            <td class="">25 251</td>
                            <td class="">26 797</td>
                            <td class="">26 797</td>
                            <td class="font-semibold pr-5">240 351</td>
                        </tr>
                        <tr>
                            <td class="text-lg font-semibold py-5 text-left pl-5">Utilisation</td>
                            <td class="text-lg font-semibold text-red">-62 475</td>
                            <td class="text-lg font-semibold text-red">-78 094</td>
                            <td class="text-lg font-semibold text-red">-85 903</td>
                            <td class="text-lg font-semibold text-red">-94 493</td>
                            <td class="text-lg font-semibold text-red">-102 053</td>
                            <td class="text-lg font-semibold text-red">-110 217</td>
                            <td class="text-lg font-semibold text-red">-117 932</td>
                            <td class="text-lg font-semibold text-red">-126 188</td>
                            <td class="text-lg font-semibold text-red">-133 759</td>
                            <td class="text-lg font-semibold text-red">-141 764</td>
                            <td class="text-lg font-semibold text-red">-148 874</td>
                            <td class="text-lg font-semibold text-red">-156 317</td>
                            <td class="text-lg font-semibold text-red pr-5">-1 358 090</td>
                        </tr>
                        <tr>
                            <td class="font-bold text-left pl-5">Index Utilisation</td>
                            <td class="font-semibold">1</td>
                            <td class="font-semibold">1,25</td>
                            <td class="font-semibold">1,05</td>
                            <td class="font-semibold">1,01</td>
                            <td class="font-semibold">1,08</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold">1,07</td>
                            <td class="font-semibold">1,07</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold pr-5">21,74</td>
                        </tr>
                        <tr>
                            <td class="font-bold text-left pl-5">Index Cumulé</td>
                            <td class="font-semibold">1</td>
                            <td class="font-semibold">1,25</td>
                            <td class="font-semibold">1,05</td>
                            <td class="font-semibold">1,01</td>
                            <td class="font-semibold">1,08</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold">1,07</td>
                            <td class="font-semibold">1,07</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold">1,06</td>
                            <td class="font-semibold pr-5">21,74</td>
                        </tr>
                        <tr>
                            <td class="mode text-left pl-5">Depens Mensuels</td>
                            <td class="text-red">-62 475</td>
                            <td class="text-red">-48 527</td>
                            <td class="text-red">-37 902</td>
                            <td class="text-red">-37 777</td>
                            <td class="text-red">-34 700</td>
                            <td class="text-red">-31 944</td>
                            <td class="text-red">-32 025</td>
                            <td class="text-red">-31 176</td>
                            <td class="text-red">-29 065</td>
                            <td class="text-red">-28 095</td>
                            <td class="text-red">-25 717</td>
                            <td class="text-red">-34 795</td>
                            <td class="font-semibold text-red pr-5">-435 198</td>
                        </tr>
                        <tr style="background-color: #e7ffd6;">
                            <td class="font-semibold text-blue text-left py-4 pl-5">Crédit Epargne</td>
                            <td class="font-semibold text-blue">0</td>
                            <td class="font-semibold text-blue">3 933</td>
                            <td class="font-semibold text-blue">24 924</td>
                            <td class="font-semibold text-blue">26 198</td>
                            <td class="font-semibold text-blue">27 776</td>
                            <td class="font-semibold text-blue">28 531</td>
                            <td class="font-semibold text-blue">30 630</td>
                            <td class="font-semibold text-blue">31 299</td>
                            <td class="font-semibold text-blue">33 469</td>
                            <td class="font-semibold text-blue">34 377</td>
                            <td class="font-semibold text-blue">36 758</td>
                            <td class="font-semibold text-blue">37 680</td>
                            <td class="font-semibold text-blue pr-5">324 052</td>
                        </tr>
                        <tr>
                            <td class="font-semibold text-left py-5 pl-5">Solde Total Cash Flow</td>
                            <td class="font-semibold">1 000 000</td>
                            <td class="font-semibold">930 653</td>
                            <td class="font-semibold">871 936</td>
                            <td class="font-semibold">813 826</td>
                            <td class="font-semibold">738 200</td>
                            <td class="font-semibold">703 531</td>
                            <td class="font-semibold">659 681</td>
                            <td class="font-semibold">598 690</td>
                            <td class="font-semibold">548 848</td>
                            <td class="font-semibold">499 325</td>
                            <td class="font-semibold">453 353</td>
                            <td class="font-semibold">407 763</td>
                            <td class="font-semibold pr-5"></td>
                        </tr>
                        <tr style="background-color: #eefde3;">
                            <td class="text-lg font-semibold text-green text-left py-5 pl-5">Utilisation By Index</td>
                            <td class="text-lg font-semibold text-green">62 475</td>
                            <td class="text-lg font-semibold text-green">78 094</td>
                            <td class="text-lg font-semibold text-green">85 903</td>
                            <td class="text-lg font-semibold text-green">94 493</td>
                            <td class="text-lg font-semibold text-green">102 053</td>
                            <td class="text-lg font-semibold text-green">110 217</td>
                            <td class="text-lg font-semibold text-green">117 932</td>
                            <td class="text-lg font-semibold text-green">126 188</td>
                            <td class="text-lg font-semibold text-green">133 759</td>
                            <td class="text-lg font-semibold text-green">141 764</td>
                            <td class="text-lg font-semibold text-green">148 874</td>
                            <td class="text-lg font-semibold text-green">156 317</td>
                            <td class="text-lg font-semibold text-green pr-5">1 358 090</td>
                        </tr>
                        <tr>
                            <td class="text-lg font-semibold text-blue text-left py-5 pl-5">Progressive</td>
                            <td class="text-lg font-semibold text-blue">0</td>
                            <td class="text-lg font-semibold text-blue">140 569</td>
                            <td class="text-lg font-semibold text-blue">226 472</td>
                            <td class="text-lg font-semibold text-blue">320 965</td>
                            <td class="text-lg font-semibold text-blue">423 018</td>
                            <td class="text-lg font-semibold text-blue">533 235</td>
                            <td class="text-lg font-semibold text-blue">651 168</td>
                            <td class="text-lg font-semibold text-blue">777 355</td>
                            <td class="text-lg font-semibold text-blue">911 114</td>
                            <td class="text-lg font-semibold text-blue">1 052 899</td>
                            <td class="text-lg font-semibold text-blue">1 201 772</td>
                            <td class="text-lg font-semibold text-blue">1 358 090</td>
                            <td class="text-lg font-semibold text-blue pr-5"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        


        <div class="clear-both h-80"></div>

    </section>
</template>